import React, { useState } from 'react';

import LibreDisclaimers from 'apps/auth/components/common/libre/LibreDisclaimers';

import { REQUEST_DELIVERY_METHODS, REQUEST_LIBRE_DISCLAIMER } from '../../RequestConstants';

// I made the separate component for further building logic
const RequestLibreFlow = (props) => {
    const [libreFlowScreen, setLibreFlowScreen] = useState(REQUEST_LIBRE_DISCLAIMER);

    return (
        <>
            {libreFlowScreen === REQUEST_LIBRE_DISCLAIMER && (
                <LibreDisclaimers
                    setLibreFlowScreen={setLibreFlowScreen}
                    primaryButtonOnClick={() => {
                        props.setScreen(REQUEST_DELIVERY_METHODS);
                        props.chooseLibreDelivery();
                    }}
                    topButtonOnClick={() => {
                        props.setScreen(REQUEST_DELIVERY_METHODS);
                    }}
                />
            )}
        </>
    );
};
export default RequestLibreFlow;
